import { Button, Modal, Space } from "antd";
import CustomTable from "components/CustomTable";
import { Link } from "react-router-dom";
import { BUDGET_TIER_LABEL, formatPriceRangeMillion } from "features/ProjectType/core";
import { useDeleteProjectPackage } from "features/ProjectType/data/hooks";
import {
  ProjectTypeState,
  VisibilityBadge,
  showProjectTypeError,
} from "features/ProjectType/presentation/components/ProjectTypeState";
export default function PackageTab({ query, projectTypeId, onTypeRefresh }) {
  const remove = useDeleteProjectPackage();
  const deleteRow = (row) =>
    Modal.confirm({
      title: "Xóa gói? Phiếu đã gửi vẫn giữ bản chụp gói.",
      okText: "Xóa",
      cancelText: "Hủy",
      onOk: async () => {
        try {
          await remove.mutate(row.id);
          await Promise.all([query.refetch(), onTypeRefresh()]);
        } catch (error) {
          showProjectTypeError(error);
          if (error.code === "PACKAGE_TIER_ALREADY_VISIBLE") await query.refetch();
        }
      },
    });
  const columns = [
    { title: "MỨC NGÂN SÁCH", width: 170, dataIndex: "budgetTier", render: (value) => BUDGET_TIER_LABEL[value] },
    { title: "TÊN GÓI", width: 150, dataIndex: "name" },
    {
      title: "TIÊU ĐỀ GÓI & MÔ TẢ NGẮN",
      render: (_, row) => (
        <>
          <strong>{row.title}</strong>
          <div style={{ whiteSpace: "pre-wrap" }}>{row.shortDescription}</div>
        </>
      ),
    },
    {
      title: "KHOẢNG GIÁ THAM KHẢO",
      width: 190,
      render: (_, row) => formatPriceRangeMillion(row.priceFromMillion, row.priceToMillion, { withCurrency: true }),
    },
    { title: "SỐ SẢN PHẨM", width: 130, dataIndex: "productCount" },
    { title: "TRẠNG THÁI", width: 150, dataIndex: "isVisible", render: (value) => <VisibilityBadge visible={value} /> },
    {
      title: "HÀNH ĐỘNG",
      width: 150,
      render: (_, row) => (
        <Space>
          <Link to={`/setting/project-type/${projectTypeId}/package/${row.id}/edit`}>Sửa</Link>
          <Button danger type="link" disabled={remove.loading} onClick={() => deleteRow(row)}>
            Xóa
          </Button>
        </Space>
      ),
    },
  ];
  return (
    <>
      <div className="project-type-toolbar">
        <span />
        <Link to={`/setting/project-type/${projectTypeId}/package/create`}>
          <Button style={{ height: 28 }}>+ Thêm gói đề xuất</Button>
        </Link>
      </div>
      <ProjectTypeState
        loading={query.loading}
        data={query.data}
        error={remove.error?.code === "FORBIDDEN" ? remove.error : query.error}
        refetch={query.refetch}
      >
        <CustomTable
          rowKey="id"
          columns={columns}
          dataSource={query.data || []}
          pagination={false}
          locale={{ emptyText: "Chưa có gói đề xuất nào. Khách chọn mức ngân sách sẽ không thấy gói." }}
        />
      </ProjectTypeState>
    </>
  );
}
